/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Tag_DescriptionInputs */

const en_directory_taxonomy_index_tag_description = /** @type {(inputs: Directory_Taxonomy_Index_Tag_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags connect products through focused capabilities, topics, and working contexts.`)
};

const zh_directory_taxonomy_index_tag_description = /** @type {(inputs: Directory_Taxonomy_Index_Tag_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签通过具体能力、主题和工作场景把产品连接起来。`)
};

/**
* | output |
* | --- |
* | "Tags connect products through focused capabilities, topics, and working contexts." |
*
* @param {Directory_Taxonomy_Index_Tag_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_tag_description = /** @type {((inputs?: Directory_Taxonomy_Index_Tag_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Tag_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_tag_description(inputs)
	return zh_directory_taxonomy_index_tag_description(inputs)
});
export { directory_taxonomy_index_tag_description as "directory.taxonomy_index.tag.description" }